function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlockscopeGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      enableBackground: "new 0 0 2000 2000"
    },
    viewBox: "509.42 343.31 1135 1313",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: -10417.918,
    x2: -9850.019,
    y1: -8221.241,
    y2: -9204.872,
    gradientTransform: "translate(11212.227 9712.98)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00b15b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#43faa1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "m1646.12 672.02-313.41-180.8-58.98 34.07v-68.14l-195.45-112.84-195.46 112.84v67.96l-58.98-33.89-313.42 180.8v361.96l58.99 34.07-58.99 34.07v225.67l195.45 112.84 58.98-34.07v68.14l313.41 180.98 313.42-180.98v-68.14l59.17 34.07 195.27-112.84v-225.67l-58.98-34.07 58.98-34.07V672.02z",
    style: {
      fill: "url(#a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1450.77 1214.95v-.01l-59.02-34.07v.04l-58.99 34.05 58.99 34.06v157.49l59.02 34.07zM1078.29 569.9zm-58.99 34.05v68.16l58.98-34.06.01-68.15-195.4-112.81v68.12l136.4 78.75zm-136.38 146.9h-.01zm195.39 112.82v-.01.01zm313.43 91.59v157.49l59.02 34.07V784.93h.01-.01l-313.45-180.96v68.12L1391.77 819z",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M705.88 1214.99v225.63l58.99-34.06v-157.51h.01l59.01-34.08-58.99-34.05zm313.41-611.03h.01v-.01zm.01 0L705.89 784.9h-.01v361.94l58.99-34.06V955.27h.01V819l254.42-146.89zm58.99 34.08.03-.01 58.99 34.06v-68.12l136.39-78.75v-68.15h-.01.01L1078.29 569.9z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1078.29 1361.84-254.4-146.87-59.01 34.08 59.03 34.08L1078.32 1430l254.43-146.91 59-34.07-58.99-34.06zM764.87 1180.9v-68.12l-58.99 34.06-136.4-78.74-59.01 34.07 195.41 112.82 59.02-34.07zm822.3-112.84-136.41 78.77v-.01l-59.02-34.07.01 68.12 59.02 34.07 195.39-112.82z",
    style: {
      opacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: -10417.829,
    x2: -10417.829,
    y1: -8057.347,
    y2: -9040.898,
    gradientTransform: "translate(11212.227 9712.98)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000",
      stopOpacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M705.88 1214.99v225.63l-195.4-112.82v-225.63l195.4 112.82zm59 34.06v225.63l313.4 180.96.04-225.63-313.44-180.96zM510.47 672.08v361.94l195.41 112.82V784.9L510.47 672.08zM764.88 819v361.9l313.41 180.94v-361.9L764.88 819z",
    style: {
      opacity: 0.23,
      fill: "url(#b)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: -10133.982,
    x2: -9566.098,
    y1: -8549.193,
    y2: -8549.193,
    gradientTransform: "translate(11212.227 9712.98)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000",
      stopOpacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "m1450.72 1214.85 195.4-112.82.01 225.64-195.4 112.82-.01-225.64zm0-68.11 195.4-112.82V672.03l-195.4 112.82v361.89zm-372.45 508.81 313.44-180.98-.01-225.64-313.43 180.98v225.64zm-.03-293.79 313.46-180.94.02-361.9-313.48 180.95v361.89z",
    style: {
      opacity: 0.16,
      fill: "url(#c)"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlockscopeGreen);
export default __webpack_public_path__ + "static/media/blockscope-green.cf8fee766a1b0803cb3d635de9a39889.svg";
export { ForwardRef as ReactComponent };